module.exports = __webpack_public_path__ + "e1fe23a0dbf5e0dc8ae963e090cbeebc.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/diamond/images/colourScale/U@2x.png
// module id = 836
// module chunks = 0